"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Grid_1 = tslib_1.__importDefault(require("@mui/material/Grid"));
const CardContentError_1 = tslib_1.__importDefault(require("../CardContentError"));
const CardError_1 = tslib_1.__importDefault(require("../CardError"));
const CardTitleError_1 = tslib_1.__importDefault(require("../CardTitleError"));
const icons_1 = require("../icons");
const SectionContent_1 = tslib_1.__importDefault(require("./SectionContent"));
/**
 * This is the component used to render an error inside of a Section component.
 *
 * @example Rendering simple SectionContentError
 * ```typescript
 *
 *    <SectionContentError small={false} contact = "mss@mnemonic.no" />
 *
 * ```
 * @category component
 */
const SectionContentError = (props) => {
    const { small = false, contact = "mss@mnemonic.no", errorCardProps = {}, ...restProps } = props;
    return (react_1.default.createElement(SectionContent_1.default, { ...restProps },
        react_1.default.createElement(Grid_1.default, { container: true, justifyContent: "center", alignItems: "center", spacing: 1 },
            react_1.default.createElement(CardError_1.default, { paperProps: { sx: { border: "none" } }, ...errorCardProps },
                react_1.default.createElement(CardTitleError_1.default, { small: small, Icon: icons_1.ErrorIcon, colorIcon: "error", colorText: "error" }),
                react_1.default.createElement(CardContentError_1.default, { small: small, contact: contact })))));
};
exports.default = SectionContentError;
